import { z } from 'zod';
/** An ObjectId serialised as a string. Opaque to clients — never parse it. */
export const objectIdSchema = z.string().regex(/^[a-f\d]{24}$/i, 'Invalid id');
/** ISO 8601 UTC string. Timestamps are never epochs on the wire. */
export const isoDateSchema = z.string().datetime();
/**
 * Indian mobile in E.164. The MVP is +91 only.
 *
 * The range is 5-9, not the 6-9 that textbooks give for Indian mobile numbers: a client
 * tester on 2026-09-19 had a live 5-series number refused. DoT has been opening further
 * levels for mobile, so treat 6-9 as out of date rather than correcting this back.
 */
export const mobileSchema = z
    .string()
    .regex(/^\+91[5-9]\d{9}$/, 'Enter a valid Indian mobile number');
/**
 * IANA timezone, stored per user. Streaks run on the user's local calendar day,
 * never UTC, so this is load-bearing.
 */
export const timezoneSchema = z.string().min(1).max(64);
/** Pagination is cursor-based, never offset. */
export const paginationQuerySchema = z.object({
    cursor: z.string().min(1).optional(),
    limit: z.coerce.number().int().min(1).max(50).default(20),
});
/** Wraps any item schema into the standard page envelope. */
export function pageSchema(item) {
    return z.object({
        items: z.array(item),
        nextCursor: z.string().nullable(),
    });
}
/** Content ships multilingual from day one. Only English content is authored in the MVP. */
export const LANGUAGES = ['en', 'ta', 'hi'];
export const languageSchema = z.enum(LANGUAGES);
export const slugSchema = z
    .string()
    .min(1)
    .max(80)
    .regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/, 'Use lowercase words separated by hyphens');
/**
 * Short reference strings — goal names, category names, plan names. Small, always loaded
 * together, so they are embedded rather than kept as one row per language.
 */
export const localizedTextSchema = z.object({
    en: z.string().trim().min(1).max(120),
    ta: z.string().trim().min(1).max(120).optional(),
    hi: z.string().trim().min(1).max(120).optional(),
});
//# sourceMappingURL=common.js.map